import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetLoanUrlB2CTransactionsUseCase extends UseCase {
  constructor({getLoanUrlB2CTransactionsRequestFactory, transactionRepositoryFactory}) {
    super()
    this._getLoanUrlB2CTransactionsRequestFactory = getLoanUrlB2CTransactionsRequestFactory
    this._transactionRepositoryFactory = transactionRepositoryFactory
  }

  @inlineError
  async execute({loanId}) {
    const loanUrlTransactionsRequest = this._getLoanUrlB2CTransactionsRequestFactory({loanId})
    const [error, loanEntityResponse] = await this._transactionRepositoryFactory.getLoanUrlB2C({
      loanUrlTransactionsRequest
    })
    if (error) throw error
    const loanUrl = loanEntityResponse.getLoanUrl()
    return loanUrl || ''
  }
}
